import { bindRequestLogic } from './utils'
import KeySettingTypes from '../actionTypes/keySetting'
import { keySettingAPI } from '../api'

const getKeySettings = bindRequestLogic({
  clientFunc: keySettingAPI.getKeySettings,
  type: KeySettingTypes.GET_KEY_SETTINGS_REQUEST,
  successType: KeySettingTypes.GET_KEY_SETTINGS_SUCCESS,
  failType: KeySettingTypes.GET_KEY_SETTINGS_FAILED
})

const updateKeySettings = bindRequestLogic({
  clientFunc: keySettingAPI.updateKeySettings,
  type: KeySettingTypes.UPDATE_KEY_SETTINGS_REQUEST,
  successType: KeySettingTypes.UPDATE_KEY_SETTINGS_SUCCESS,
  failType: KeySettingTypes.UPDATE_KEY_SETTINGS_FAILED
})

const uploadFactoryPublicKey = bindRequestLogic({
  clientFunc: keySettingAPI.uploadFactoryPublicKey,
  type: KeySettingTypes.UPLOAD_FACTORY_PUBLIC_KEY_REQUEST,
  successType: KeySettingTypes.UPLOAD_FACTORY_PUBLIC_KEY_SUCCESS,
  failType: KeySettingTypes.UPLOAD_FACTORY_PUBLIC_KEY_ERROR
})

const deleteFactoryPublicKey = bindRequestLogic({
  clientFunc: keySettingAPI.deleteFactoryPublicKey,
  type: KeySettingTypes.DELETE_FACTORY_PUBLIC_KEY_REQUEST,
  successType: KeySettingTypes.DELETE_FACTORY_PUBLIC_KEY_SUCCESS,
  failType: KeySettingTypes.DELETE_FACTORY_PUBLIC_KEY_ERROR
})

const getKeySettingsComments = bindRequestLogic({
  clientFunc: keySettingAPI.getKeySettingsComments,
  type: KeySettingTypes.GET_KEY_SETTINGS_COMMENTS_REQUEST,
  successType: KeySettingTypes.GET_KEY_SETTINGS_COMMENTS_SUCCESS,
  failType: KeySettingTypes.GET_KEY_SETTINGS_COMMENTS_ERROR
})

const addKeySettingsComment = bindRequestLogic({
  clientFunc: keySettingAPI.addKeySettingsComment,
  type: KeySettingTypes.ADD_KEY_SETTINGS_COMMENT_REQUEST,
  successType: KeySettingTypes.ADD_KEY_SETTINGS_COMMENT_SUCCESS,
  failType: KeySettingTypes.ADD_KEY_SETTINGS_COMMENT_ERROR
})

const updateKeySettingsComment = bindRequestLogic({
  clientFunc: keySettingAPI.updateKeySettingsComment,
  type: KeySettingTypes.UPDATE_KEY_SETTINGS_COMMENT_REQUEST,
  successType: KeySettingTypes.UPDATE_KEY_SETTINGS_COMMENT_SUCCESS,
  failType: KeySettingTypes.UPDATE_KEY_SETTINGS_COMMENT_ERROR
})

const deleteKeySettingsComment = bindRequestLogic({
  clientFunc: keySettingAPI.deleteKeySettingsComment,
  type: KeySettingTypes.DELETE_KEY_SETTINGS_COMMENT_REQUEST,
  successType: KeySettingTypes.DELETE_KEY_SETTINGS_COMMENT_SUCCESS,
  failType: KeySettingTypes.DELETE_KEY_SETTINGS_COMMENT_ERROR
})

export default [
  getKeySettings,
  updateKeySettings,
  uploadFactoryPublicKey,
  deleteFactoryPublicKey,
  getKeySettingsComments,
  addKeySettingsComment,
  updateKeySettingsComment,
  deleteKeySettingsComment
]
